import { extendTheme } from '@chakra-ui/react';

const colors = {
  brand: {
    50: '#E6F6FF',
    100: '#BAE3FF',
    200: '#7CC4FA',
    300: '#47A3F3',
    400: '#2186EB',
    500: '#0967D2',
    600: '#0552B5',
    700: '#03449E',
    800: '#01337D',
    900: '#002159'
  }
};

const config = {
  initialColorMode: 'light',
  useSystemColorMode: false
};

const styles = {
  global: {
    body: {
      bg: 'white',
      color: 'gray.800'
    },
    // Improve touch targets on mobile
    'button, a, input, select': {
      minHeight: { base: '44px', md: 'auto' },
      minWidth: { base: '44px', md: 'auto' }
    }
  }
};

const components = {
  Container: {
    baseStyle: {
      maxW: 'container.xl',
      px: { base: 4, md: 8 },
      py: { base: 4, md: 8 }
    }
  },
  Card: {
    baseStyle: {
      container: {
        bg: 'white',
        borderRadius: 'xl',
        boxShadow: '0 4px 6px rgba(160, 174, 192, 0.2)',
        border: '1px solid',
        borderColor: 'gray.100',
        transition: 'all 0.2s ease-in-out',
        _hover: {
          transform: { base: 'none', md: 'translateY(-2px)' },
          boxShadow: { base: 'none', md: '0 8px 15px rgba(160, 174, 192, 0.3)' },
          borderColor: 'gray.200'
        }
      }
    }
  },
  Button: {
    variants: {
      cyber: {
        bg: 'brand.500',
        color: 'white',
        borderRadius: 'lg',
        fontWeight: 'semibold',
        px: { base: 4, md: 6 },
        py: { base: 3, md: 'auto' },
        fontSize: { base: 'sm', md: 'md' },
        _hover: {
          bg: 'brand.600',
          transform: { base: 'none', md: 'translateY(-1px)' },
          boxShadow: { base: 'none', md: '0 4px 12px rgba(33, 134, 235, 0.4)' }
        },
        _active: {
          bg: 'brand.700',
          transform: 'translateY(0)',
          boxShadow: 'none'
        }
      }
    }
  },
  Badge: {
    baseStyle: {
      bg: 'gray.100',
      color: 'gray.800',
      px: 3,
      py: 1,
      borderRadius: 'full',
      fontSize: { base: 'xs', md: 'sm' },
      fontWeight: 'medium',
      transition: 'all 0.2s',
      cursor: 'pointer',
      _hover: {
        bg: 'gray.200',
        transform: { base: 'none', md: 'translateY(-1px)' }
      }
    }
  },
  Modal: {
    baseStyle: {
      dialog: {
        bg: 'white',
        borderRadius: 'xl',
        boxShadow: 'xl',
        border: '1px solid',
        borderColor: 'gray.200',
        mx: { base: 4, md: 'auto' },
        my: { base: 'auto', md: '3.75rem' },
        maxW: { base: 'calc(100% - 32px)', md: '500px', lg: '600px' }
      },
      overlay: {
        bg: 'blackAlpha.600',
        backdropFilter: 'blur(8px)'
      }
    }
  },
  Input: {
    variants: {
      filled: {
        field: {
          bg: 'gray.50',
          borderRadius: 'lg',
          fontSize: { base: 'sm', md: 'md' },
          height: { base: '44px', md: 'auto' },
          _hover: {
            bg: 'gray.100'
          },
          _focus: {
            bg: 'gray.100',
            borderColor: 'brand.400'
          }
        }
      }
    },
    defaultProps: {
      variant: 'filled'
    }
  },
  Heading: {
    baseStyle: {
      color: 'gray.800',
      letterSpacing: 'tight',
      fontSize: {
        base: 'xl',
        md: '2xl',
        lg: '3xl'
      }
    }
  },
  Text: {
    baseStyle: {
      color: 'gray.800',
      fontSize: { base: 'sm', md: 'md' }
    }
  },
  Tabs: {
    baseStyle: {
      tab: {
        minHeight: { base: '44px', md: 'auto' },
        fontSize: { base: 'sm', md: 'md' }
      }
    }
  },
  Table: {
    baseStyle: {
      th: {
        fontSize: { base: 'xs', md: 'sm' }
      },
      td: {
        fontSize: { base: 'sm', md: 'md' }
      }
    }
  }
};

export const theme = extendTheme({
  colors,
  config,
  styles,
  components,
  breakpoints: {
    sm: '30em',
    md: '48em',
    lg: '62em',
    xl: '80em',
    '2xl': '96em',
  }
});